import { useWC26UserTeams } from '../../queries';
import NameLink from '../NameLink/NameLink';
import Spinner from '../Spinner/Spinner';
import './UserTeamsWC26.css';

function UserTeamsWC26() {
  const [loading, userTeams, error] = useWC26UserTeams();

  return (
    <div className="user-teams-wc26-container">
      <h2>Team Allocations</h2>
      {error ? <p className="user-teams-wc26-error">Failed to load team allocations.</p>
        : loading || !userTeams ? <Spinner />
          : (
            <table className="user-teams-wc26-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Team 1</th>
                  <th>Team 2</th>
                </tr>
              </thead>
              <tbody>
                {userTeams.length > 0 && userTeams.map((userTeam) => (
                  <tr key={userTeam.name}>
                    <td><NameLink name={userTeam.name} /></td>
                    <td>{userTeam.team1}</td>
                    <td>{userTeam.team2}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
    </div>
  );
}

export default UserTeamsWC26;
